import {Component, ElementRef, EventEmitter, Input, Output, SimpleChanges, ViewChild} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { IRequestValidateDocument } from './file-upload.model';
import { FileUploadMappingService } from './file-upload.mapping.service';
import { FileUploadService } from './file-upload.service';
import { AlertService } from 'src/app/core/services/alert.service';

@Component({
  standalone: false,
  selector: 'app-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.css']
})
export class FileUploadComponent {
    @Input() form!: FormGroup;
    @Input() formLabelPhoto!: string;
    @Input() disabled!: boolean;
    @Input() width!: string;
    @Input() height!: string;
    @Input() label!: string;
    @Input() tipo!: string;
    @Input() messageInfo!: string;

    @Output() fileUploaded = new EventEmitter<boolean>();

    @ViewChild('fileInput') fileInput!: ElementRef;

    fileName: string = '';
    fileSize: number = 0;

    isDragging = false;

    constructor(
        private mappingService: FileUploadMappingService,
        private service: FileUploadService,
        private alertService: AlertService
    ) {}

    ngOnChanges(changes: SimpleChanges) {
        if (changes['disabled']) {
          this.onDisabledChange(changes['disabled'].currentValue);
        }
    }

    onDisabledChange(isDisabled: boolean) {
        if (isDisabled) {
          this.limpiarInputFile();
        }
    }

    onFileSelected(event: Event) {
        const input = event.target as HTMLInputElement;
        if (input.files && input.files[0]) {
            const file = input.files[0];
            this.fileName = file.name;
            this.fileSize = parseFloat((file.size / 1024).toFixed(2));
            let fileSize = parseFloat((file.size / 1048576).toFixed(2));
            const fileExtension = this.fileName.split('.').pop()?.toLowerCase();

            if(fileSize > 1){
                this.alertService.show({
                    width: "35vw",
                    iconColor: "var(--color-secundario)",
                    icon: "bx bx-error-circle",
                    title: "Lo sentimos",
                    detail: "El archivo excede el tamaño permitido de 1MB.",
                })
                this.limpiarInputFile();
                return;
            }

            if (fileExtension !== 'pdf' && fileExtension !== 'pdf') {
                this.alertService.show({
                    width: "35vw",
                    iconColor: "var(--color-secundario)",
                    icon: "bx bx-error-circle",
                    title: "Lo sentimos",
                    detail: "El archivo debe ser de tipo PDF",
                })
                this.limpiarInputFile();
                return;
            }

            const reader = new FileReader();
            reader.readAsDataURL(file);

            reader.onload = () => {
                const base64String = reader.result as string;
                this.prepareValidateDocument(base64String, this.tipo);
                this.onFileUploadSuccess();
            };

            reader.onerror = (error) => {
                console.error('Error al convertir el archivo a Base64:', error);
            };
        }
    }

    prepareValidateDocument(documento: string, tipoDocumento: string){
        const resp = this.mappingService.prepareDataRequestValidateDocument(documento,tipoDocumento)
        this.validateDocument(resp, documento);
    }

    validateDocument(request: IRequestValidateDocument, documento: string) {

        this.service.validateDocument(request)
            .subscribe(
            {
                next: (data) => {
                    let dataTmp = data;
                    if(dataTmp) {
                        if(dataTmp.Succeeded){
                            if(dataTmp.Data.IsValid){
                                this.form?.get(this.formLabelPhoto)?.patchValue(documento);
                            } else {
                                this.alertService.show({
                                    width: "35vw",
                                    iconColor: "var(--color-secundario)",
                                    icon: "bx bx-error-circle",
                                    title: "Lo sentimos",
                                    detail: "No se pudo realizar la operación",
                                })
                                this.limpiarInputFile();
                            }
                        }else{
                            this.alertService.show({
                                width: "35vw",
                                iconColor: "var(--color-secundario)",
                                icon: "bx bx-error-circle",
                                title: dataTmp.Message.Title,
                                detail: dataTmp.Message.DetailUser,
                            })
                            this.limpiarInputFile();
                        }
                    }else{
                        this.alertService.show({
                            width: "35vw",
                            iconColor: "var(--color-secundario)",
                            icon: "bx bx-error-circle",
                            title: dataTmp.Message.Title,
                            detail: dataTmp.Message.DetailUser,
                        })
                        this.limpiarInputFile();
                    }
                },
                error: (error) => {
                    this.alertService.show({
                        width: "35vw",
                        iconColor: "var(--color-secundario)",
                        icon: "bx bx-error-circle",
                        title: "Lo sentimos",
                        detail: "No se pudo realizar la operación",
                    })
                    this.limpiarInputFile();
                }
            }
        );
    }

    onDragOver(event: DragEvent) {
        event.preventDefault();
        this.isDragging = true;
    }

    onDragLeave(event: DragEvent) {
        event.preventDefault();
        this.isDragging = false;
    }

    onDrop(event: DragEvent) {
        if(this.disabled) return;

        event.preventDefault();
        this.isDragging = false;

        if (event.dataTransfer?.files && event.dataTransfer.files[0]) {
            const file = event.dataTransfer.files[0];
            this.fileName = file.name;
            this.fileSize = parseFloat((file.size / 1024).toFixed(2));
            let fileSize = parseFloat((file.size / 1048576).toFixed(2));
            const fileExtension = this.fileName.split('.').pop()?.toLowerCase();
            if(fileSize > 1){
                this.alertService.show({
                    width: "35vw",
                    iconColor: "var(--color-secundario)",
                    icon: "bx bx-error-circle",
                    title: "Lo sentimos",
                    detail: "El archivo excede el tamaño permitido de 1MB.",
                })
                this.limpiarInputFile();
                return;
            }


            if (fileExtension !== 'pdf' && fileExtension !== 'pdf') {
                this.alertService.show({
                    width: "35vw",
                    iconColor: "var(--color-secundario)",
                    icon: "bx bx-error-circle",
                    title: "Lo sentimos",
                    detail: "El archivo debe ser de tipo PDF",
                })
                this.limpiarInputFile();
                return;
            }

            this.convertFileToBase64(file);
        }
    }

    convertFileToBase64(file: File) {
        const reader = new FileReader();
        reader.readAsDataURL(file);

        reader.onload = () => {
            const base64String = reader.result as string;
            this.prepareValidateDocument(base64String, this.tipo);
            this.onFileUploadSuccess();
        };

        reader.onerror = (error) => {
            console.error('Error al convertir el archivo a Base64:', error);
        };
    }

    clearDocument(event: Event): void {
        event.stopPropagation();
        this.limpiarInputFile();
    }

    limpiarInputFile() {
        this.fileName = '';
        this.fileSize = 0;

        if (this.fileInput) {
          this.fileInput.nativeElement.value = '';
        }

        if (this.form && this.formLabelPhoto) {
          this.form.get(this.formLabelPhoto)?.setValue(null);
        }
    }

    triggerFileInputClick(){
        const fileInput = document.getElementById(this.formLabelPhoto) as HTMLInputElement;
        if (fileInput) {
            fileInput.click();
        } else {
            console.error('No se encontró el input de archivo con id:', this.formLabelPhoto);
        }
    }

    openDialogInfo(){
        this.alertService.show({
            width: "35vw",
            iconColor: "var(--color-secundario)",
            icon: "bx bxs-info-circle",
            title: "Importante",
            detail: this.messageInfo,
        })
    }

    onFileUploadSuccess() {
        // Lógica para manejar la subida exitosa del archivo
        this.fileUploaded.emit(true); // Emitir evento indicando que el archivo fue subido
    }


}
